var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtherium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#ff3131;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,0.9c-0.4,0-0.7,0.2-1,0.5c0,0,0,0-0.1,0.1L12,28.1c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.1,0.2 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2 c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1l17,9.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1 c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0l17-9.7c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2-0.1-0.2c0,0,0-0.1,0-0.1L31,1.4 c0,0,0,0-0.1-0.1C30.7,1.1,30.4,0.9,30,0.9z M30,4v18.7l14.3,6.2L30,37.3V22.7L14.9,28L30,4z M12.8,33.7c-0.3,0-0.5,0.2-0.7,0.4 c-0.4,0.4-0.4,1.1-0.1,1.5l17,23.1c0,0,0,0,0.1,0c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0.1,0.1,0.1,0.1c0.2,0.1,0.3,0.1,0.5,0.1 s0.4,0,0.5-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0.1,0l17-23.1c0.3-0.5,0.3-1.1-0.1-1.5c-0.4-0.4-1-0.5-1.5-0.2 L30,43.2l-16.4-9.4C13.4,33.7,13.1,33.6,12.8,33.7z M17.4,38.8L30,46.2v9.5L17.4,38.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherium);
export default __webpack_public_path__ + "static/media/etherium.9667a1925a0f9bd80313ad124b08f737.svg";
export { ForwardRef as ReactComponent };